import {useState} from 'react';
import { styles } from '../Style.js';

function X() {
    return (
        <span style={{...styles.boxText, ...styles.boxTextX}}>X</span>
    );
}
function O() {
    return (
        <span style={{...styles.boxText, ...styles.boxTextO}}>O</span>
    );
}


export function Box(props) {
    const neutralStyle = {
        backgroundColor: "#ffffff"
    };
    const activeStyle = {
        backgroundColor: "#e2f7ff",
    };

    const [styling, setStyling] = useState(neutralStyle);

    const handleMouseOver = () => {
        if (props.status === "") {
            setStyling( activeStyle );
        } else {
            setStyling( neutralStyle );
        }
    }

    return (
        <div style={{...styles.box, ...styling}} onMouseOver={handleMouseOver} onMouseOut={() => { setStyling(neutralStyle); }} onClick={() => {setStyling(neutralStyle);props.handleClick(props)}}>
            {props.status === "" ? null : (props.status === "X" ? <X /> : <O />) }
        </div>
    );
}
